const languages = [
  {
    name: "Portuguese",
    subtitle: "Native",
    flag: "🇵🇹",
  },
  {
    name: "English",
    subtitle: "C1 (Cambridge CAE)",
    flag: "🇬🇧",
  },
  {
    name: "French",
    subtitle: "Basic",
    flag: "🇫🇷",
  },
];

export default languages;
